export default __webpack_public_path__ + "static/media/blogcard11.20874bcb.png";